import { useEffect, useState } from "react";
import { useArtis } from "./useArtis.js";
/**
 * The accumulated product catalog: subscribes to `artis.v1.products` with the same
 * optional `filters`, folds the delta stream into a snapshot, and returns it as a stable
 * array. Starts empty; catches up immediately once the SDK is live (the catalog surface
 * replays known products on subscribe). Returns `[]` while the SDK is down. A changed
 * filter resubscribes with a fresh snapshot.
 */
export const useProducts = (filters) => {
    const artis = useArtis();
    const kind = filters?.kind;
    const [products, setProducts] = useState([]);
    useEffect(() => {
        if (!artis) {
            setProducts([]);
            return;
        }
        const byId = new Map();
        setProducts([]);
        return artis.v1.products.subscribe((delta) => {
            for (const product of delta.upserts ?? [])
                byId.set(product.id, product);
            for (const id of delta.removes ?? [])
                byId.delete(id);
            setProducts([...byId.values()]);
        }, kind === undefined ? undefined : { kind });
    }, [artis, kind]);
    return products;
};
//# sourceMappingURL=useProducts.js.map